// extracted by mini-css-extract-plugin
export default {"wrapper":"_lkh8__wrapper","chapterWrapper":"D2HsR__chapterWrapper","chapter":"d8D6y__chapter","title":"I28KU__title TextClip","time":"XCmGT__time"};